import * as React from 'react';
import ProductCompareRepository from "../../repository/ProductCompareRepository";
import useReduxState from 'src/hooks/useReduxState';
import { useProductStore } from 'src/hooks/product';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const ProductCompareClearAll = (props) => {
    const [showNoProductError, setNoProductError] = useReduxState(false, 'setNoProductError');
    const [{ }, { remove_All_Data }, { }] = useProductStore()
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const onClear = async () => {
        await remove_All_Data();
        // new BroadcastChannel('product-compare-toggled').postMessage({});
        await new ProductCompareRepository().fetchAllData();
        setNoProductError(true)
        system_alert_indicator({
            name: 'productCompare',
            message: '<b>There are no compare products for this account.</b>',
            type: "info",
            isDisplay: false,
            isDisplayIcon:false
        })
    }

    return (
        <>
            {props.type == 'button' ?
                <button className="bs5 btn btn-secondary"
                    onClick={async () => { onClear(); }} >CLEAR ALL</button>
                : <a href={'#'} className="compare-clear-link"
                    onClick={async (e) => {
                        e.preventDefault();
                        onClear();
                    }} >CLEAR ALL</a>
            }
        </>
    );
}

export default ProductCompareClearAll;